<template>
  <div class="homework">
    <div class="content">
      <div v-for="(e, i) in works" :key="e.name" :style="`background-image: url(${e.cover})`">
        <router-link :to="`/work/0${i + 1}`" v-text="e.name"></router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Homework",
  data() {
    return {
      works: [
        { name: "北京会馆分布格局的时空分析", cover: "/img/01_1.png" },
        { name: "《红楼梦》情感叙事的可视化分析", cover: "/img/02_1.png" },
        { name: "以明代儒学传承和传教士活动为例的中西比较研究", cover: "/img/03_2.png" },
        { name: "社会网络分析视角下的心学泰州学派——以《明儒学案》为中心", cover: "/img/04_1.png" },
        { name: "基于文本引用的《论语》语义变化分析——以“道”为研究中心", cover: "/img/05_1.png" },
        { name: "用数字人文方法探究“巴克特里亚：千城之国”", cover: "/img/06_3.png" },
        { name: "时空视域下的《水浒传》研究", cover: "/img/07_2.jpg" },
        { name: "西游故事主题分析", cover: "/img/08_1.png" },
        { name: "陶瓷瓷瓶的本体建构", cover: "/img/09_5.png" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.homework {
  .content {
    display: flex;
    flex-wrap: wrap;
    margin: 1rem 0 0;
    div {
      flex: 30% 1 1;
      height: 15vmax;
      margin: 0.2rem;
      color: #fff;
      background-size: cover;
      background-position: center;
      a {
        display: block;
        height: 100%;
        text-decoration: none;
        font-size: 1vmax;
        color: #fff;
        background: #0009;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 2rem;
        transition: 0.1s;
      }
      :hover {
        background: #0002;
        color: transparent;
      }
    }
  }
}
</style>
